import { createSelector } from 'reselect';

const systemConfigurationSelector = state => state.systemConfiguration.systemConfigs;

export const getSystemConfigs = createSelector(
    systemConfigurationSelector,
    systemConfigurations => systemConfigurations,
);
